import {
   serverPostRequestByUrlAndDataWithMsg,
   serverPostRequestByUrlAndDataWithMsgForExport,
} from 'app/services/utilsServices';
import promiseFactory from 'util/promiseFactory';

const SSA_SECURE_BASE_URL = `${ process.env.REACT_APP_MS_SYNDICATED_SPONSORED_ADS_SECURE }`;

// https://stageservices.upward.net/v1/ssa/secure/syndication-site/get-select
export const getSiteSelectOptionsSSA = promiseFactory.postPayload(`${ SSA_SECURE_BASE_URL }syndication-site/get-select`);
export const getPublisherSelectOptionsSSA = promiseFactory.getSuggestionsForSelect(`${ SSA_SECURE_BASE_URL }syndication-publisher/get-select`);
export const getChannelSelectOptionsSSA = promiseFactory.postPayload(`${ SSA_SECURE_BASE_URL }syndication-ad-channel/get-select`);


// AD MANAGER
const AD_MANAGER = `${ SSA_SECURE_BASE_URL }ad-manager/`;
export const syndicatedSponsoredAdsAdManagerDetails = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsg(`${ AD_MANAGER }details`, requestData);
};

export const syndicatedSponsoredAdsAdManagerExport = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsgForExport(`${ AD_MANAGER }export`, requestData);
};

export const syndicatedSponsoredAdUnitCreate = promiseFactory.postPayload(`${ AD_MANAGER }add`);
export const syndicatedSponsoredAdUnitEdit = promiseFactory.postPayload(`${ AD_MANAGER }edit`);
export const syndicatedSponsoredAdUnitGet = (id) => promiseFactory.postPayload(`${ AD_MANAGER }get?id=${ id }`);
export const syndicatedSponsoredAdUnitClone = (id) => promiseFactory.postPayload(`${ AD_MANAGER }clone?id=${ id }`);

// EDIT SPONSORED PARTNER
const EDIT_SPONSORED_PARTNER = `${ SSA_SECURE_BASE_URL }sponsored-partner-config/`;
export const syndicatedSponsoredPartnerConfigDetails = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsg(`${ EDIT_SPONSORED_PARTNER }details`, requestData);
};

export const syndicatedSponsoredPartnerConfigExport = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsgForExport(`${ EDIT_SPONSORED_PARTNER }export`, requestData);
};

export const syndicatedSponsoredPartnerConfigSave = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsg(`${ EDIT_SPONSORED_PARTNER }save`, requestData);
};

// PIT RAW DATA
const PIT_RAW_DATA = `${ SSA_SECURE_BASE_URL }publisher-integ-tool/`;
export const syndicatedSponsoredPitRawDataDetails = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsg(`${ PIT_RAW_DATA }details`, requestData);
};

export const syndicatedSponsoredPitRawDataExport = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsgForExport(`${ PIT_RAW_DATA }export`, requestData);
};

// ADS REPORTING
const ADS_REPORTING = `${ SSA_SECURE_BASE_URL }report/`;
export const syndicatedSponsoredReportingDetails = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsg(`${ ADS_REPORTING }details`, requestData);
};

export const syndicatedSponsoredReportingExport = (requestData) => {
   return serverPostRequestByUrlAndDataWithMsgForExport(`${ ADS_REPORTING }export`, requestData);
};


// Ad Channel
const AD_CHANNEL_BASE_URL = `${ SSA_SECURE_BASE_URL }syndication-ad-channel/`;
export const createSyndicatedAdChannel = promiseFactory.postPayload(`${ AD_CHANNEL_BASE_URL }create`);

